import './Footer.css';

const Footer = () => {
return (
        <div className='footer'>© 2024 Andrew Capaldo</div>
    )
}

export default Footer